import { useMemo } from 'react';
import { Card } from 'antd';
import './kpi.css';

const KPICard = ({ title, value, icon, color, format = 'number', loading, onClick }) => {
  const formattedValue = useMemo(() => {
    if (loading) return '...';

    if (format === 'currency') {
      return `$${parseFloat(value || 0).toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    }

    if (format === 'percent') {
      return `${value || 0}%`;
    }

    return (value || 0)?.toLocaleString('es-MX');
  }, [value, format, loading]);

  return (
    <Card className="kpi-card" onClick={onClick} style={{ cursor: 'pointer' }}>
      <div className="kpi-content">
        <div className={`kpi-icon-wrapper kpi-${color}`}>
          {icon}
        </div>
        <div className="kpi-stats">
          <div className="kpi-value">{formattedValue}</div>
          <div className="kpi-title">{title}</div>
        </div>
      </div>
    </Card>
  );
};

export default KPICard;